// Wait for n milliseconds (promise)
export function wait(ms) {
  return new Promise(function (r) {
    return setTimeout(r, ms)
  })
}

// Throttle
export function throttle(func, delay) {
  let timer = null
  return function () {
    const _this = this
    const args = []
    for (let _len = arguments.length, _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key]
    }
    if (timer === null) {
      timer = setTimeout(function () {
        func.apply(_this, args)
        timer = null
      }, delay)
    }
  }
}

// Injection d'une icon svg
export function icon(id, addClass) {
  return (
    '<svg class="vp-icon vp-icon-' +
    id +
    (addClass ? ' ' + addClass : '') +
    '" aria-hidden="true"><use xlink:href="#icon-' +
    id +
    '"></use></svg>'
  )
}

// Traitement des chaines de caractères pour la recherche
// (suppression des diacritics + minuscule)
export function normalizeString(str) {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
}

// Store spécifique aux gestionnaires d'évenements (event, observer)
// conserve la référence de chaque listener en vue d'une destruction "propre", sans fuites mémoire
export const listeners = {
  _list: [],
  addEvent: (el, ev, cb) => {
    const type = 'event'
    const object = [el, ev, cb]
    listeners._list.push({ type, object })
    el.addEventListener(ev, cb)
  },
  addObserver: (callback, options) => {
    const type = 'observer'
    const object = new IntersectionObserver(callback, options)
    listeners._list.push({ type, object })
    return object
  },
  destroy: () => {
    if (listeners.list.length > 0) {
      for (const [type, object] of listeners._list) {
        switch (type) {
          case 'event':
            // eslint-disable-next-line no-case-declarations
            const [el, ev, cb] = object
            el.removeEventListener(ev, cb)
            break
          case 'observer':
            object.disconnect()
            break
        }
      }
    }
  },
}
